// extracted by mini-css-extract-plugin
module.exports = {"menuItem":"MenuItem_menuItem__2EnMH","active":"MenuItem_active__8NGW7"};